import { reactive, computed, onBeforeMount, watch } from '@vue/composition-api'
import { commonErrorMessage } from '@/util/common'
import * as _ from 'lodash'

export const BookmarkEdit = (props, context) => {
  const store = context.root.$store
  const { bookmark } = store.state
  
  const data = reactive({
    name: '',
    tags: [],
    // 現在設定中のものを省いたタグ一覧
    allTags: computed(() => {
      const currentTagNames = _.map(data.tags, 'name')
      return _.filter(bookmark.tags, tag => !_.includes(currentTagNames, tag.name))
    }),
    tagInput: null
  })

  // 初期値を設定する
  const orginalData = store.getters['bookmark/getCurrentList']
  data.name = orginalData.title
  data.tags = _.cloneDeep(orginalData.tags)

  const validation = reactive({
    isTitleChanged: computed(() => {
      return data.name !== orginalData.title 
    }),
    isTagChanged: computed(() => {
      const orgTagNames = _.map(orginalData.tags, tag => tag.name)
      const updateTagNames = _.map(data.tags, tag => tag.name)
      const addTags = _.difference(updateTagNames, orgTagNames)
      const removeTags = _.difference(orgTagNames, updateTagNames)

      return addTags.length > 0 || removeTags.length > 0
    }),
    isChanged: computed(() => {
      return validation.isTitleChanged || validation.isTagChanged
    }),
    isSubmit: false,
    title: {
      require: computed(() => data.name !== '')
    },
    all: computed(() => {
      // 決定ボタン押下前(isSubmit:false)の場合はチェックしない
      return validation.isSubmit &&
        validation.title.require
    })
  })

  const action = reactive({
    enterInput: (event) => {
      if (event.keyCode === 13) {
        action.insertTag()
      }
    },
    insertTag: () => {
      const name = data.tagInput ? data.tagInput.trim() : ''
      if (!name) {
        return false
      }
      // 同名タグがすでに設定されている場合は入力欄をクリアして終了
      if (_.map(data.tags, 'name').includes(name)) {
        data.tagInput = ''
        return
      }

      const tag = {
        id: null,
        name: name
      }
      action.settingTag(tag)
      data.tagInput = ''
    },
    settingTag: (tag) => {
      data.tags.push(tag)
    },
    removeTag: (removeTag) => {
      const tagsIndex = _.findIndex(data.tags, tag => tag.name === removeTag.name)
      data.tags.splice(tagsIndex, 1)
    },
    save: async() => {
      validation.isSubmit = true
      if (validation.all) {
        // 変更点がなければ閉じるだけ
        if (!validation.isChanged) {
          context.emit('closeBookmarkEdit')
        } else {
          const tagChanged = validation.isTagChanged
          const tagNames = _.map(data.tags, tag => tag.name)
          const params = {
            id: bookmark.currentId,
            title: data.name,
            tags: tagNames
          }
          await store
            .dispatch('bookmark/update', params)
            .then(response => {
              const { data } = response
              if (data.status === 0) {
                store.dispatch('common/showToast', { text: 'ブックマークを更新しました。' })
                // タグが更新されていれば一覧のタグを取得しなおす
                if (tagChanged) {
                  store.dispatch('bookmark/getTags')
                }
              } else {
                commonErrorMessage(response)
              }
            })
            // .then(() => {
            //   // タグが更新されていれば一覧のタグを取得しなおす
            //   if (tagChanged) {
            //     await store.dispatch('bookmark/getTags')
            //   }
            // })
          context.emit('closeBookmarkEdit')
          context.emit('save')
        }
      }
    }
  })

  const state = reactive({
    isOpenHistoryTags: false
  })
  const close = () => {
    context.emit('closeBookmarkEdit')
  }
  return {
    data,
    action,
    validation,
    state,
    close
  }
}
